/**
 * User-facing maintenance mode copy — safe to import from the browser bundle.
 * Keep this file free of Node/Lambda imports (no process.env, db, etc.).
 */

export const ENROLLMENT_SUSPENDED_DURING_MAINTENANCE_MESSAGE =
  'Class enrollment is suspended while the site is under maintenance. Please try again after maintenance is complete.';

export const PARENT_LOGIN_BLOCKED_DURING_MAINTENANCE_MESSAGE =
  'Sign-in is unavailable while the site is under maintenance. Please check back soon.';

export const ADMIN_MAINTENANCE_BANNER_MESSAGE =
  'Landing page and parent sign-in are off; enrollment is suspended. You can still preview and manage the app.';
